<template>
<div class="text-center">
    <v-bottom-sheet inset persistent v-model="loaderActive" >
      <v-card tile>
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>Загрузка файла</v-list-item-title>
              <v-list-item-subtitle>{{file ? file.name ? file.name : '' : ''}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-spacer></v-spacer>

            <v-list-item-icon
              class="ml-0"
              :class="{ 'mr-3': $vuetify.breakpoint.mdAndUp }"
            >
              <!-- <v-btn icon @click="() => {loaderActive = false}">
                <v-icon>mdi-close</v-icon>
              </v-btn> -->
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
export default {
  props: {
    loaderActive: Boolean,
    file: null
  },
  computed: {
  },
  data: () => ({
  }),
  watch: {
  },
  components: {
  },
  methods: {
  },
  mounted () {
  }
  /* eslint-enable */
}
</script>
